<script setup lang="ts">
const {
  label = null,
  labelIcon = null,
  value = null,
  valueIcon = null,
  labelProps = {},
  valueProps = {}
} = defineProps<{
  label?: string | null;
  labelIcon?: string | null;
  labelIconColor?: string | null;
  value?: string | null;
  valueIcon?: string | null;
  valueIconColor?: string | null;
  labelProps?: Record<string, unknown>;
  valueProps?: Record<string, unknown>;
}>();
</script>

<template>
  <div class="key-value">
    <dt v-if="$slots.label || label" v-bind="labelProps" data-testid="key-value-label">
      <slot v-if="labelIcon" name="labelIcon">
        <v-icon :icon="labelIcon" :color="labelIconColor" size="1em" />
      </slot>
      <slot name="label">{{ label }}</slot>
    </dt>

    <dd v-if="$slots.value || value" v-bind="valueProps" data-testid="key-value-value">
      <slot v-if="valueIcon" name="valueIcon">
        <v-icon :icon="valueIcon" :color="valueIconColor" size="1em" />
      </slot>
      <slot name="value">{{ value }}</slot>
    </dd>
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
.key-value {
  display: flex;
  flex-direction: var(--key-value-direction, column);
  align-items: var(--key-value-align-items, unset);
  gap: var(--key-value-gap, #{$spacing-2});
  padding: var(--key-value-padding-y, 0) var(--key-value-padding-x, 0);

  dt {
    @include typography('body-sm-bold');
    font-size: var(--key-value-label-font-size, 14px) !important;
  }

  dd {
    @include typography('body-md');
    font-size: var(--key-value-value-font-size, 16px) !important;
  }
}

dt .v-icon {
  margin: 0 6px 2px 0;
}

dd .v-icon {
  margin: 0 6px 1px 0;
}
</style>
